"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateComponentPluginDefintion = void 0;
const RactiveComponentPlugin_1 = require("auto-widget-framework/src/Plugin/RactiveComponent/RactiveComponentPlugin");
const RactiveComponentPluginDefinition_1 = require("auto-widget-framework/src/Plugin/RactiveComponent/RactiveComponentPluginDefinition");
const IContainerInjection_1 = require("auto-widget-framework/src/Container/IContainerInjection");
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
const Ractive = require("ractive");
class DateComponent extends RactiveComponentPlugin_1.default {
    constructor(definition, dateFormatter) {
        super(definition);
        this.dateFormatter = dateFormatter;
    }
    /**
     * @inheritDoc
     */
    static create(definition, container) {
        return new this(definition, container.get("formatter.date"));
    }
    /**
     * @inheritDoc
     */
    getElementName() {
        return "date";
    }
    /**
     * @inheritDoc
     */
    getComponent() {
        const self = this;
        return Ractive.extend({
            template: "{{ formattedDate }}",
            computed: {
                formattedDate: function () {
                    try {
                        return this.data.formattedPrice = self.dateFormatter.format(this.get("date"), this.get("format"));
                    }
                    catch (err) {
                        console.error("Failed rendering date.");
                        console.error(err);
                        return "-";
                    }
                }
            }
        });
    }
}
exports.default = DateComponent;
Mixin_1.default(DateComponent, IContainerInjection_1.default);
exports.DateComponentPluginDefintion = new RactiveComponentPluginDefinition_1.default({
    id: "date_component",
    class: DateComponent
});
